<template>
<div>
  <el-autocomplete size="small" v-model="listQuery.userName" :fetch-suggestions="querySearchAsync" :placeholder="placeholderValue" :trigger-on-focus="false" value-key="cPersonName" :debounce=0 @select="handleSelect" @blur="checkinput"><i class="el-icon-search" slot="suffix" @click="handleSelComp"></i></el-autocomplete>

  <el-dialog class="dialog-mini" top="15vh" v-el-drag-dialog :title="titleValue" :visible.sync="dialogAccessVisible">
      <access-erp-user ref="accessErpUser" v-if="dialogAccessVisible" :userName="listQuery.userName" :accinfoid="listQuery.accinfoid"  @close="dialogAccessVisible=false" @closeMoule="closeMoule"/>
  </el-dialog>
</div>
</template>

<script>
import { GetErpUser } from '@/api/users';
import accessErpUser from '@/components/SelectErpUser';
import elDragDialog from '@/directive/el-dragDialog';

export default {
  name: 'auto-erp-user',
  components: { accessErpUser },
  directives: { elDragDialog },
  props: {
    cPersonName: [String],
    accinfoid: [String],
    placeholderValue: {
      type: String,
      default: '请输入'
    },
    titleValue: {
      type: String,
      default: '选择用户'
    }
  },
  data() {
    return {
      list: [],
      dialogAccessVisible: false, // select access dialog
      compobject: {
        cDepCode: '',
        cDepName: '',
        cPersonCode: '',
        cPersonName: ''
      },
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        userName: this.cPersonName,
        accinfoid: this.accinfoid
      }
    };
  },
  watch: {
    cPersonName(val) {
      this.listQuery.userName = val;
      if (this.cPersonName !== '') {
        this.list.push({
          cPersonName: this.cPersonName
        });
      }
    },
    cPersonCode(val) {
      this.listQuery.customerId = val;
    }
  },
  mounted() {
    if (this.cPersonName !== '') {
      this.list.push({
        cPersonName: this.cPersonName
      });
    }
  },
  methods: {
    closeMoule(e) {
      this.dialogAccessVisible = false;
      this.list = e[0].list;
      this.listQuery.userName = e[0].cPersonName;
      this.compobject.cPersonName = e[0].cPersonName;
      this.compobject.cPersonCode = e[0].cPersonCode;
      this.compobject.cDepName = e[0].cDepName;
      this.compobject.cDepCode = e[0].cDepCode;
      this.postselval(this.compobject);
    },
    handleSelComp() {
      this.dialogAccessVisible = true;
    },
    querySearchAsync(queryString, cb) {
      GetErpUser(this.listQuery).then(response => {
        this.list = response.data.map(u => ({ ...u }));
        // console.log(this.list)
        cb(this.list);
      });
    },
    handleSelect(item) {
      this.compobject.cPersonName = item.cPersonName;
      this.compobject.cPersonCode = item.cPersonCode;
      this.compobject.cDepName = item.cDepName;
      this.compobject.cDepCode = item.cDepCode;
      this.postselval(this.compobject);
      // console.log(item)
    },
    checkinput() {
      var result = this.list.find(u => u.cPersonName === this.listQuery.userName);
      if (result === undefined) {
        this.listQuery.userName = '';
        this.compobject.cPersonName = '';
        this.compobject.cPersonCode = '';
        this.compobject.cDepName = '';
        this.compobject.cDepCode = '';
        this.postselval(this.compobject);
      }
    },
    postselval(val) {
      this.$emit('update:cPersonName', val.cPersonName);
      const postval = {
        erpUserCode: val.cPersonCode,
        erpDeptName: val.cDepName,
        erpDeptCode: val.cDepCode
      };
      this.$emit('postdata', postval);
    }
  }
};
</script>
<style>
  .el-autocomplete {
    width: 100%;
  }
</style>
